import { motion } from "framer-motion";
import { ShieldAlert, Mail, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { HostHelpLogo } from "@/components/hosthelp-logo";

export function PlanBlockedScreen({ planStatus, onLogout }) {
  const isPending = planStatus === "pending";

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#faf8f4] px-4" data-testid="plan-blocked-screen">
      <motion.div
        initial={{ opacity: 0, y: 24, scale: 0.96 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md text-center"
      >
        <div className="rounded-3xl border border-[#ebe5d9] bg-white p-10 shadow-lg">
          <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-[#FF9500]/10">
            <ShieldAlert className="h-10 w-10 text-[#FF9500]" />
          </div>

          <h1 className="mb-3 text-2xl font-bold text-[#2a2520]" data-testid="plan-blocked-title">
            {isPending ? "Plan Activation Pending" : "Plan Suspended"}
          </h1>

          <p className="mb-6 text-sm leading-relaxed text-[#8a7e6e]" data-testid="plan-blocked-message">
            {isPending
              ? "Your hotel has been registered successfully. Please contact the administrator to activate your plan. You cannot access the application until it is activated."
              : "Your plan has been suspended due to pending payment. Please contact the administrator to reactivate your plan."}
          </p>

          <div className="mb-6 rounded-2xl border border-[#ebe5d9] bg-[#faf8f4] p-4">
            <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-[#8a7e6e]">Contact Administrator</p>
            <a
              href="mailto:help@hosthelp.ai"
              className="inline-flex items-center gap-2 text-base font-semibold text-[#FF9500] transition-colors hover:text-[#cc7700]"
              data-testid="plan-blocked-email"
            >
              <Mail className="h-4 w-4" />
              help@hosthelp.ai
            </a>
          </div>

          <Button
            variant="outline"
            className="rounded-xl"
            onClick={onLogout}
            data-testid="plan-blocked-logout"
          >
            <LogOut className="mr-2 h-4 w-4" />
            Sign Out
          </Button>
        </div>

        <div className="mt-6 flex justify-center opacity-40">
          <HostHelpLogo size="xs" variant="dark" />
        </div>
      </motion.div>
    </div>
  );
}
